"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.yearlyCost = exports.suggestedPlans = exports.getAmount = exports.getBalance = exports.gen = void 0;
const moment_1 = __importDefault(require("moment"));
const __1 = __importDefault(require(".."));
const __2 = require("../../..");
const case_vouchers_1 = require("../../case-vouchers");
const payment_plans_1 = require("../../payment-plans");
const vouchers_1 = require("../../vouchers");
const setup_1 = require("../../vouchers/setup");
const reminderTimespan = 5;
const paymentDeadlineTimespan = 5;
const cancelTimespan = 5;
const gen = (caseVouchers, documents, expirationSettings, config, options = {}) => {
    let plan = config.plan || [];
    const startDate = (0, moment_1.default)(config.startDate);
    let filteredVouchers = __1.default.vouchers.postProcessing(caseVouchers, {
        includeDeletedVouchers: false,
        includeExpiredVouchers: false,
        includeIrrecoverableVouchers: false,
    });
    if (config.interestFree) {
        filteredVouchers = interestFreePeriod(filteredVouchers, config.interestFree);
    }
    const lastEntry = plan[plan.length - 1];
    let currDate = lastEntry
        ? addInterval(config.interval, (0, moment_1.default)(lastEntry.date))
        : startDate.clone();
    if (!options.migration && currDate.isBefore((0, moment_1.default)().startOf('day'))) {
        throw new Error(`Start date can't be in the past`);
    }
    if (config.amountUpfront && !plan.length) {
        if (typeof config.amountUpfront != 'number') {
            throw new Error(`Please provide a number, not a ${typeof config.amountUpfront}`);
        }
        if (config.amountUpfront <= 0) {
            throw new Error(`Up front amount cannot be less or equals 0`);
        }
        const upfrontDate = (0, moment_1.default)(config.dateUpfront);
        const newEntry = {
            reminder: upfrontDate.clone().format(),
            date: upfrontDate.add(reminderTimespan, 'days').clone().format(),
            deadline: upfrontDate
                .add(paymentDeadlineTimespan, 'days')
                .clone()
                .format(),
            cancel: upfrontDate.add(cancelTimespan, 'days').clone().format(),
            type: payment_plans_1.PaymentPlanEntryTypes.UPFRONT,
            amount: config.amountUpfront,
            dateEdited: false,
            amountEdited: true,
            interestAmount: null,
            key: Math.random().toString(),
            status: payment_plans_1.PaymentPlanEntryStatus.PENDING,
        };
        plan = plan.concat([newEntry]);
    }
    if (config.duration) {
        if (typeof config.duration != 'number') {
            throw new Error(`Please provide a number, not a ${typeof config.duration}`);
        }
        if (config.duration <= 0) {
            throw new Error(`Duration cannot be less or equals 0`);
        }
        for (let i = 0; i < config.duration; i++) {
            const newEntry = createNewNormalEntry(currDate, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, 0, false);
            plan = plan.concat([newEntry]);
            currDate = addInterval(config.interval, currDate);
        }
        plan = calculateAmounts(filteredVouchers, documents, expirationSettings, plan);
    }
    else if (config.amount) {
        const existingPlanAmount = plan.reduce((acc, e) => { var _a; return acc + (e.status != payment_plans_1.PaymentPlanEntryStatus.SETTLED ? (_a = e.amount) !== null && _a !== void 0 ? _a : 0 : 0); }, 0);
        if (typeof config.amount != 'number') {
            throw new Error(`Please provide a number, not a ${typeof config.amount}`);
        }
        if (config.amount <= 0) {
            throw new Error(`Amount cannot be less or equals 0`);
        }
        const totalDebt = -__1.default.overview.balance(filteredVouchers);
        if (options.migration) {
            if (totalDebt < 0) {
                throw new Error('No debt');
            }
            const cD = currDate.clone();
            plan.push({
                reminder: cD.subtract(reminderTimespan, 'days').clone().format(),
                date: cD.add(reminderTimespan, 'days').clone().format(),
                deadline: cD.add(paymentDeadlineTimespan, 'days').clone().format(),
                cancel: cD.add(cancelTimespan, 'days').clone().format(),
                type: payment_plans_1.PaymentPlanEntryTypes.REST,
                amount: 0,
                dateEdited: false,
                amountEdited: false,
                interestAmount: null,
                key: Math.random().toString(),
                status: payment_plans_1.PaymentPlanEntryStatus.PENDING,
            });
        }
        else {
            if (config.amount + existingPlanAmount > totalDebt) {
                throw new Error('The total debt is less than the monthly payment');
            }
            if (config.amountUpfront &&
                config.amount + existingPlanAmount > totalDebt) {
                throw new Error('The total debt is less than the sum of monthly payment and upfront payment');
            }
        }
        let i = 0;
        const upfrontToBeSubtracted = existingPlanAmount + (config.amountUpfront ? config.amountUpfront : 0);
        let minDuration = Math.floor((totalDebt - upfrontToBeSubtracted) / config.amount);
        let newPlan = plan;
        minDuration = minDuration < 0 ? 0 : minDuration;
        while (lastEntryIsNotBelowAmount(plan, !!config.amountUpfront) ||
            minDuration >= i) {
            plan = newPlan;
            if (i > 179) {
                break;
            }
            newPlan = addAnotherEntryToPlan(plan, currDate, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, config.interval, createNewNormalEntry(currDate, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, config.amount, true));
            currDate = addInterval(config.interval, currDate);
            if (i >= minDuration) {
                const endBalance = (0, exports.getBalance)(caseVouchers, documents, expirationSettings, newPlan);
                const addQuantityEntries = Math.floor(Math.abs(endBalance) / config.amount);
                if (addQuantityEntries > 0) {
                    minDuration += addQuantityEntries;
                    if (minDuration > 179) {
                        minDuration = 179;
                    }
                    else {
                        continue;
                    }
                }
                plan = calculateAmounts(filteredVouchers, documents, expirationSettings, plan);
            }
            i++;
        }
        if (typeof exports.getAmount.rest(plan) === 'number'
            ? exports.getAmount.rest(plan) < 500
            : false) {
            plan = plan.slice(0, -1);
        }
        if (-(0, exports.getBalance)(caseVouchers, documents, expirationSettings, plan) > 0 &&
            !config.interestFree) {
            plan[plan.length - 1] = Object.assign(Object.assign({}, plan[plan.length - 1]), { amount: plan[plan.length - 1].amount +
                    -(0, exports.getBalance)(caseVouchers, documents, expirationSettings, plan) });
        }
    }
    else {
        throw new Error('Please select either an amount or a duration');
    }
    return addInterestAmounts(filteredVouchers, documents, expirationSettings, plan);
};
exports.gen = gen;
const addAnotherEntryToPlan = (plan, date, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, interval, entry) => {
    plan = plan.filter((pE) => pE.type !== payment_plans_1.PaymentPlanEntryTypes.REST);
    if (entry) {
        plan = plan.concat([entry]);
    }
    let cD = date.clone();
    cD = addInterval(interval, cD);
    plan = plan.concat([
        {
            reminder: cD.subtract(reminderTimespan, 'days').clone().format(),
            date: cD.add(reminderTimespan, 'days').clone().format(),
            deadline: cD.add(paymentDeadlineTimespan, 'days').clone().format(),
            cancel: cD.add(cancelTimespan, 'days').clone().format(),
            type: payment_plans_1.PaymentPlanEntryTypes.REST,
            amount: 0,
            dateEdited: false,
            amountEdited: false,
            interestAmount: null,
            key: Math.random().toString(),
            status: payment_plans_1.PaymentPlanEntryStatus.PENDING,
        },
    ]);
    return plan;
};
const lastEntryIsNotBelowAmount = (plan, amountUpfront) => {
    if (!amountUpfront && plan.length === 0) {
        return true;
    }
    if (amountUpfront && plan.length === 1) {
        return true;
    }
    return exports.getAmount.entry(plan) < exports.getAmount.rest(plan);
};
const createNewNormalEntry = (currDate, reminderTimespan, paymentDeadlineTimespan, cancelTimespan, amount, amountEdited) => {
    const cD = currDate.clone();
    return {
        reminder: cD.subtract(reminderTimespan, 'days').clone().format(),
        date: cD.add(reminderTimespan, 'days').clone().format(),
        deadline: cD.add(paymentDeadlineTimespan, 'days').clone().format(),
        cancel: cD.add(cancelTimespan, 'days').clone().format(),
        type: payment_plans_1.PaymentPlanEntryTypes.NORMAL,
        amount,
        dateEdited: false,
        amountEdited,
        interestAmount: null,
        key: Math.random().toString(),
        status: payment_plans_1.PaymentPlanEntryStatus.PENDING,
    };
};
const addInterval = (interval, currDate) => {
    switch (interval) {
        case payment_plans_1.Interval['TWO-WEEKS']:
            currDate.add(2, 'weeks');
            break;
        case payment_plans_1.Interval.WEEK:
            currDate.add(1, 'week');
            break;
        case payment_plans_1.Interval.MONTH:
            currDate.add(1, 'month');
            break;
        case payment_plans_1.Interval['TWO-MONTHS']:
            currDate.add(2, 'months');
            break;
        case payment_plans_1.Interval.QUARTERLY:
            currDate.add(3, 'months');
            break;
    }
    return currDate;
};
const calculateAmounts = (caseVouchers, documents, expirationSettings, plan) => {
    const amountWithOverpaymentsPrEntry = (getEndAmountWithOverpayment(caseVouchers, documents, expirationSettings, plan) -
        plan
            .filter((p) => p.amountEdited)
            .reduce((acc, e) => (e.status != payment_plans_1.PaymentPlanEntryStatus.SETTLED ? e.amount || 0 : 0) +
            acc, 0)) /
        plan.filter((p) => !p.amountEdited).length;
    const newPlan = plan.map((p) => (Object.assign(Object.assign({}, p), { amount: p.amountEdited ? p.amount : amountWithOverpaymentsPrEntry })));
    return findEntryAmount(caseVouchers, documents, expirationSettings, newPlan).map((entry) => (Object.assign(Object.assign({}, entry), { interestAmount: null })));
};
const getEndAmountWithOverpayment = (caseVouchers, documents, expirationSettings, plan) => {
    const latestDate = getLatestDate(plan);
    const vs = __1.default.interest.calculate(caseVouchers, documents, expirationSettings, latestDate, false, undefined, { preventInterestExpiration: true });
    return -Math.round(__1.default.overview.balance(vs));
};
const getLatestDate = (plan) => {
    const latestEntry = plan[plan.length - 1];
    if (!latestEntry) {
        throw new Error('No dates found');
    }
    return (0, moment_1.default)(latestEntry.date).format();
};
const bys = [];
let num = 1;
while (num < 1000000) {
    bys.unshift(Math.round(num));
    num = num * 4;
}
const findEntryAmount = (caseVouchers, documents, expirationSettings, newPlan) => {
    return bys.reduce((newPlan, by) => reducePlan(caseVouchers, documents, expirationSettings, newPlan, by), newPlan);
};
const reducePlan = (caseVouchers, documents, expirationSettings, plan, by) => {
    let newPlan;
    let run = true;
    let max = 0;
    while (run) {
        newPlan = plan.map((p) => (Object.assign(Object.assign({}, p), { amount: p.amountEdited ? p.amount : (p.amount || 0) - by })));
        if ((0, exports.getBalance)(caseVouchers, documents, expirationSettings, newPlan) < 0 ||
            max > 1000) {
            run = false;
            continue;
        }
        else {
            plan = newPlan;
        }
        max++;
    }
    return plan;
};
const getBalance = (caseVouchers, documents, expirationSettings, plan) => {
    const latestDate = getLatestDate(plan);
    const futureVouchers = __1.default.interest.calculate(caseVouchers.concat(plan.map((p) => genFakeDeposit(p.status != payment_plans_1.PaymentPlanEntryStatus.SETTLED
        ? parseInt(`${p.amount || 0}`)
        : 0, (0, moment_1.default)(p.date).format()))), documents, expirationSettings, latestDate, false, undefined);
    return __1.default.overview.balance(futureVouchers);
};
exports.getBalance = getBalance;
exports.getAmount = {
    upfront: (plan) => {
        const entry = plan.find((p) => p.type === payment_plans_1.PaymentPlanEntryTypes.UPFRONT);
        return entry && entry.amount;
    },
    entry: (plan) => {
        const entry = JSON.parse(JSON.stringify(plan))
            .reverse()
            .find((p) => p.type === payment_plans_1.PaymentPlanEntryTypes.NORMAL);
        return entry && entry.amount;
    },
    total: (plan) => plan.reduce((acc, entry) => acc + (entry.amount || 0), 0),
    rest: (plan) => {
        const entry = plan.find((p) => p.type === payment_plans_1.PaymentPlanEntryTypes.REST);
        return entry && entry.amount;
    },
};
const suggestedPlans = (caseVouchers, documents, expirationSettings, tenant, creditor) => {
    const plans = creditor.paymentPlansConfig ||
        tenant.paymentPlansConfig ||
        payment_plans_1.defaultPaymentPlansConfig;
    const suggestions = [];
    const startDate = (0, moment_1.default)()
        .add(1, 'months')
        .startOf('month')
        .add((0, moment_1.default)().format('HH:mm:ss'));
    const filteredVouchers = __1.default.vouchers.postProcessing(caseVouchers, {
        includeDeletedVouchers: false,
        includeExpiredVouchers: false,
        includeIrrecoverableVouchers: false,
    });
    Object.values(plans.plans).forEach((plan) => suggestions.push(Object.assign({ plan: (0, exports.gen)(JSON.parse(JSON.stringify(filteredVouchers)), documents, expirationSettings, {
            startDate: startDate.format(),
            interval: payment_plans_1.Interval.MONTH,
            duration: plan.duration,
        }) }, plan)));
    const sugg = suggestions
        .map((plan) => ({
        monthlyAmount: exports.getAmount.entry(plan.plan),
        months: plan.plan.length,
        from: plan.plan[0] && plan.plan[0].date,
        to: plan.plan[plan.plan.length - 1] && plan.plan[plan.plan.length - 1].date,
        total: exports.getAmount.total(plan.plan),
        id: plan.id,
    }))
        .filter((p) => (p.monthlyAmount || 0) >= plans.minEntryAmount);
    return sugg;
};
exports.suggestedPlans = suggestedPlans;
const YEAR = 31536000000;
const yearlyCost = (startDate, vouchers, documents, expirationSettings, plan, initialCosts) => {
    const startDateMS = new Date(startDate).getTime();
    const years = plan.reduce((acc, entry) => {
        const year = Math.ceil((new Date(entry.date).getTime() - startDateMS) / YEAR);
        const y = year > 0 ? year : 1;
        acc[`${y}`] = {
            year: y,
            from: startDateMS + YEAR * (y - 1),
            to: startDateMS + YEAR * y,
            entries: ((acc[`${y}`] && acc[`${y}`].entries) || []).concat(entry),
        };
        return acc;
    }, {});
    const ys = Object.values(years).sort((a, b) => a.year - b.year);
    const calculatedYears = [];
    let previousDistributedVouchers = __1.default.interest.calculate(JSON.parse(JSON.stringify(vouchers)).filter((voucher) => !initialCosts
        .map((v) => v.caseVoucherId)
        .includes(voucher.caseVoucherId)), documents, expirationSettings, startDate, false, undefined);
    for (let i = 0; i < ys.length; i++) {
        const year = ys[i];
        const costs = i > 0 ? [] : initialCosts;
        const nextDistributedVouchers = __1.default.interest.calculate(JSON.parse(JSON.stringify(vouchers)), documents, expirationSettings, (0, moment_1.default)(year.to).format(), false, undefined);
        const previousInterest = -__1.default.overview.balanceCategory(previousDistributedVouchers, vouchers_1.VoucherCategory.INTEREST);
        const nextInterest = -__1.default.overview.balanceCategory(nextDistributedVouchers, vouchers_1.VoucherCategory.INTEREST);
        const previousPrincipal = -__1.default.overview.balanceCategory(previousDistributedVouchers, vouchers_1.VoucherCategory.PRINCIPAL);
        const costsTotal = -__1.default.overview.balance(costs);
        calculatedYears.push({
            costs,
            costFraction: (nextInterest - previousInterest + costsTotal) / previousPrincipal,
            periodFrom: year.from,
            periodTo: year.to,
        });
        previousDistributedVouchers = nextDistributedVouchers;
    }
    return calculatedYears;
};
exports.yearlyCost = yearlyCost;
const genFakeDeposit = (amount, date) => ({
    amount,
    category: 'transaction',
    createdAt: date,
    date: date,
    caseVoucherId: '',
    tags: [],
    appendix: null,
    currency: __2.Currency.EUR,
    voucherTypeId: vouchers_1.VoucherTypeIds.DEPOSIT,
    id: 1,
    label: '',
    state: null,
    caseId: '',
    createdBy: null,
    details: {},
    dueDate: null,
    importId: null,
    interest: null,
    interestEndDate: null,
    interestStartDate: null,
    lineItems: null,
    referenceCaseVoucherId: null,
    referenceId: null,
    setting: null,
    source: case_vouchers_1.CaseVoucherSource.Collector,
    tenantId: '',
    text: null,
    transactionAccountId: null,
    expired: false,
    expirationManualSet: false,
    expirationDate: null,
    expirationFromDate: null,
    irrecoverableDate: null,
    cardType: null,
    paymentType: null,
    paymentMethodId: null,
    transactionImportId: null,
    deletedAt: null,
    deletedBy: null,
    exported: false,
    settingDetails: null,
});
const addInterestAmounts = (caseVouchers, documents, expirationSettings, plan) => {
    for (let i = 0; i < plan.length; i++) {
        const entry = plan[i];
        const futureVoucherDeposits = plan
            .slice(0, i + 1)
            .map((p) => genFakeDeposit(p.status != payment_plans_1.PaymentPlanEntryStatus.SETTLED
            ? parseInt(`${p.amount}`)
            : 0, (0, moment_1.default)(p.date).format()));
        const _vouchers = __1.default.interest.calculate(__1.default.vouchers
            .postProcessing(caseVouchers, {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        })
            .concat(futureVoucherDeposits), documents, expirationSettings, (0, moment_1.default)(entry.date).clone().format(), false, undefined);
        plan[i] = Object.assign(Object.assign({}, plan[i]), { interestAmount: __1.default.overview.balanceCategory(_vouchers, vouchers_1.VoucherCategory.INTEREST) });
    }
    return plan;
};
const interestFreePeriod = (caseVouchers, interestFree) => {
    const moreCaseVouchers = [];
    for (let i = 0; i < caseVouchers.length; i++) {
        const caseVoucher = caseVouchers[i];
        if (!(caseVoucher.setting &&
            setup_1.CaseVoucherInterestSettings.includes(caseVoucher.setting))) {
            continue;
        }
        else {
            if (caseVoucher.interestEndDate) {
                throw new Error('Interest end date already defined and cannot be handled.');
            }
            const interestEndDate = (0, moment_1.default)(interestFree.from).isAfter(caseVoucher.interestStartDate)
                ? interestFree.from
                : caseVoucher.interestStartDate;
            caseVouchers[i] = Object.assign(Object.assign({}, caseVoucher), { interestEndDate });
            if (interestFree.to) {
                const caseVoucherSetting = {
                    setting: caseVoucher.setting,
                    settingDetails: caseVoucher.settingDetails,
                };
                moreCaseVouchers.push(Object.assign(Object.assign({ interestStartDate: (0, moment_1.default)(interestEndDate).isAfter(interestFree.to)
                        ? interestEndDate
                        : interestFree.to, interestEndDate: null, amount: 0, referenceCaseVoucherId: caseVoucher.referenceCaseVoucherId, interest: caseVoucher.interest, caseVoucherId: `${Math.random()}`, category: caseVoucher.category, createdAt: caseVoucher.createdAt, date: interestFree.to, id: Math.random(), currency: caseVoucher.currency, voucherTypeId: caseVoucher.voucherTypeId, tags: caseVoucher.tags }, caseVoucherSetting), { label: caseVoucher.label, appendix: null, caseId: caseVoucher.caseId, createdBy: caseVoucher.createdBy, details: caseVoucher.details, dueDate: caseVoucher.dueDate, importId: caseVoucher.importId, lineItems: caseVoucher.lineItems, referenceId: caseVoucher.referenceId, source: caseVoucher.source, state: caseVoucher.state, tenantId: caseVoucher.tenantId, text: caseVoucher.text, transactionAccountId: caseVoucher.transactionAccountId, expired: caseVoucher.expired, expirationManualSet: caseVoucher.expirationManualSet, expirationDate: caseVoucher.expirationDate, expirationFromDate: caseVoucher.expirationFromDate, irrecoverableDate: caseVoucher.irrecoverableDate, cardType: caseVoucher.cardType, paymentType: caseVoucher.paymentType, paymentMethodId: caseVoucher.paymentMethodId, transactionImportId: caseVoucher.transactionImportId, deletedAt: caseVoucher.deletedAt, deletedBy: caseVoucher.deletedBy, exported: caseVoucher.exported }));
            }
        }
    }
    return caseVouchers.concat(moreCaseVouchers);
};
//# sourceMappingURL=index.js.map